<template>
  <div :class="classes">
       <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" v-loading="loading" isAddPageToRouter :isOutside="isOutside">
      <wt-table :list="tableData" :labels="tabeLabels">
      </wt-table>
       </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀

const prefixCls = 'pt-cps-payment-table'
export default {
  name: 'pt-cps-payment-table',
  props: {
    tabeLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    loading: {
      type: Boolean,
      default: false
    },
    isOutside: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    },
    resetPage () {
      this.$refs.table.resetPage()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
